// "RAG Is Burning Money — I Built a Cost-Aware Retrieval Layer" — EAKC cost control.
// Cold Compute / Neon kit. ~118s @ 30fps. Companion to the docs/articles deep-dive.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; keep contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  same answer billed twice; simple query, frontier model
  problem: { start: 150, duration: 480 }, //   0:05–0:21  three failure modes: over-fetch · no cache · no routing
  tiers: { start: 630, duration: 450 }, //     0:21–0:36  task-purpose tiers — cheap by default, ~40× spread
  router: { start: 1080, duration: 480 }, //   0:36–0:52  7-strategy router sets the budget (kills over-fetch)
  cache: { start: 1560, duration: 450 }, //    0:52–1:07  semantic cache 0.97 / 30min / fail-closed
  code: { start: 2010, duration: 690 }, //     1:07–1:30  the real constants (semantic-cache + query-router)
  guard: { start: 2700, duration: 510 }, //    1:30–1:47  $55 vs $1.80 — ledger + 3 guards + 402 not 429
  outro: { start: 3210, duration: 330 }, //    1:47–1:58
} as const;

export const TOTAL_DURATION = 3540; // 118s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
